/**
 * The a3s features an asset's hire can grant.
 *
 * A feature is an a3s-side capability - what the asset is hired to DO, named
 * after the capability rather than after the product a customer bought it
 * under. That distinction is the point: `waste_sense` and `load_sense` are two
 * products that both need vehicle tracking, so the capability is named once and
 * granted by both.
 *
 * Not to be confused with a Vision Hub hire purpose (`waste_sense`), which is
 * hub product vocabulary. That translation is this package's job and has
 * exactly one home: {@link ./hire-purposes.ts}.
 *
 * Nor with an a3s-reports report type (`wastesense`), which is a narrower,
 * separately-persisted vocabulary. Every report type is granted by a feature,
 * but most features grant no report; a3s-reports owns that map.
 *
 * Alphabetical, which is also the order `_provisioning_open_asset_features`
 * aggregates them in - so a feature array read back from the database matches
 * one this package produced, element for element.
 */
export const FEATURES = ["gate", "line_crossings", "vehicle_tracker", "waste_detection"] as const;

/** An a3s capability granted by a hire. */
export type Feature = (typeof FEATURES)[number];
